<template>
  <div class="d-flex flex-wrap card-info">
    <input-field
      label="Name"
      label-position="top"
      class="px-1 col-12 col-sm-4 pt-1"
    >
      <div class="text-left overflow-hidden">
        {{ alert.name || '-' }}
      </div>
    </input-field>
    <input-field
      label="Healthcheck Name"
      label-position="top"
      class="px-1 col-12 col-sm-4 pt-1"
    >
      <div class="text-left overflow-hidden">
        <span
          v-if="!alert.healthcheck"
          class="text-danger"
        >
          Healthcheck not found!
        </span>
        <a
          v-else
          class="link"
          @click="onHealthcheckClick(alert.healthcheck.id)"
        >
          {{ alert.healthcheck.name || '-' }}
        </a>
      </div>
    </input-field>

    <input-field
      label="Last Modified"
      label-position="top"
      class="px-1 col-12 col-sm-4 pt-1"
    >
      <span v-b-tooltip.hover.bottom="`${formatOffsetDateTime(alert.updateDate)}`">
        {{ alert.updateDate ? `${timeSince(alert.updateDate)} ago` : '-' }}
      </span>
    </input-field>

    <input-field
      label="Message"
      label-position="top"
      class="px-1 col-12 col-sm-8 pt-1"
    >
      <div class="text-left overflow-hidden">
        {{ alert.message || '-' }}
      </div>
    </input-field>

    <input-field
      label="Providers"
      label-position="top"
      class="px-1 col-12 col-sm-4 pt-1"
    >
      <b-avatar-group
        v-if="alert.providers && alert.providers.length > 0"
        size="42px"
        overlap="0"
      >
        <div
          v-for="(provider, index) in groupAlertProviders(alert.providers)"
          :key="index"
        >
          <b-avatar
            v-b-tooltip.hover
            class="ml-1 provider-type-badge pull-up"
            :badge="provider.childs.length.toString()"
            :title="returnProviderTitles(provider)"
            :src="changeTypeSrc(provider.type)"
          />
        </div>
      </b-avatar-group>
      <div v-else>
        --
      </div>
    </input-field>
  </div>
</template>

<script>
export default {
  name: 'AlertDetails',
  data() {
    return {
      /* eslint-disable global-require */
      googleChat: require('@/assets/svg/icons/google-chat.svg'),
      slack: require('@/assets/svg/icons/slack.svg'),
      discord: require('@/assets/svg/icons/discord.svg'),
      /* eslint-enable global-require */
    }
  },
  computed: {
    gettingAlert() {
      return this.$store.state.alerts.gettingAlert
    },
    alert() {
      return this.$store.state.alerts.alert
    },
  },
  methods: {
    onHealthcheckClick(healthcheckId) {
      this.$router.push({
        name: 'healthchecks-details',
        params: { id: this.id, healthcheckId },
      })
    },
    groupAlertProviders(providers) {
      const types = [...new Set(providers.map(el => el.type))]
      const arr = []
      types.forEach(type => {
        const childs = providers.filter(el => el.type === type)
        arr.push({ type, childs })
      })
      return arr
    },
    changeTypeSrc(type) {
      if (type === 0) {
        return this.googleChat
      }
      if (type === 1) {
        return this.slack
      }
      if (type === 2) {
        return this.discord
      }
      return null
    },
    returnProviderTitles(provider) {
      let title = ''
      provider.childs.forEach((e, index) => {
        if (index !== 0) {
          title += `, ${e.name}`
        } else {
          title += e.name
        }
      })
      return title
    },
  },
}
</script>

<style lang="scss" scoped>
.card-info::v-deep {
  .card-header {
    padding: 16px 0;
  }
  .card-body {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 14px;
  }
  .provider-type-badge {
    background-color: #fff !important;
    border: 1px solid #f6f7f9;
  }
}
</style>
